// Root model
export class MediationServiceModel {
  body: MediationBody = new MediationBody();
}

export class MediationBody {
  ProcessName: string = "DC Create Update SR Web WF";
  DCMethod: string = "SAVEASDRAFT";
  SiebelMessage: SiebelMessage = new SiebelMessage();
}

export class SiebelMessage {
  xmlns: string = "http://www.siebel.com/xml/DC%20Query%20Member%20Info";
  MessageId: string = "";
  MessageType: string = "Integration Object";
  IntObjectName: string = "DCMemSRIO";
  IntObjectFormat: string = "Siebel Hierarchical";
  ListOfDCMemSRIO: ListOfDCMemSRIO = new ListOfDCMemSRIO();
}

export class ListOfDCMemSRIO {
  "DC Mem SR": DCMemSR = new DCMemSR();
}

export class DCMemSR {
  "DC Channel":string="Online";
  "SR Sub Type": string = "Mediation";
  "DC Member Name(Arabic)": string = "";
  "DC Member Name(English)": string = "";
  "SR Type": string = "";
  "DC Person Incharge": string = "";
  "DC Person Incharge Mobile": string = "";
  "DC Person Incharge Email Address": string = "";
  "DC Person Incharge Telephone Number": string = "";
  "DC Person Incharge Designation": string = "";
  "DC Person Incharge PO Box": string = "";
  "DC Person Incharge Country": string = "";
  "DC Person Incharge City": string = "";
  "DC Postal Address": string = "";
  "DC Complainant Addr2": string = "";
  "DC Member Email Id": string = "";
  "DC ATA Consent": string = "Y";
  "DC Dispute Amt Flag": string = "Y";
  "DC Invoice Amount": string = "";
  "DC Nature Of Dispute": string = "";
  "DC Parties": string = "L/F";
  "DC Dispute In Brief Flag": string = "Y";
  "Description": string = "";
  "DC Complainant Request": string = "";
  "DC Non Chargeable": string = "Y";
  "DC Case Dispute Sector": string = "";
  "DC Case Respondent Check": string = "Yes";
  "DC SVS Member Number": string = "";
  "DC Respondent Member Name": string = "";
  "DC Respondant Name": string = "";
  "DC Admin Srv Details": string = "";
  "DC Respondant Telephone Number": string = "";
  "DC Respondant PO Box Number": string = "";
  "DC MRM CEO Email": string = "";
  "DC Respondant Postal Address": string = "";
  "DC Respondant Address 2": string = "";
  "DC Respondant City": string = "";
  "DC Respondant Country": string = "";
  "Account Id": string = "";
  "SR Number": string = ""
}
